module.exports = "https://static.wanderu.com/static/media/ca.8d6232bb.svg";